// Import model
import { DataviewTaxRatesResponse } from '../models/DataviewTaxRatesResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterTaxRatesRequest } from '../models/FilterTaxRatesRequest';
import { TaxRates } from '../models/TaxRates';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterTaxRatesRequestSerializer } from './FilterTaxRatesRequestSerializer';
import { TaxRatesSerializer } from './TaxRatesSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewTaxRatesResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewTaxRatesResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewTaxRatesResponse instance
   */
  static deserialize(json: string): DataviewTaxRatesResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewTaxRatesResponse instance
   */
  static fromObject(obj: any): DataviewTaxRatesResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewTaxRatesResponse');
    }


    const instance: DataviewTaxRatesResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        TaxRatesSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterTaxRatesRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewTaxRatesResponse instances
   */
  static deserializeArray(json: string): DataviewTaxRatesResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewTaxRatesResponse instance to a JSON string
   */
  static serialize(instance: DataviewTaxRatesResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewTaxRatesResponse instance to a plain object
   */
  static toObject(instance: DataviewTaxRatesResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        TaxRatesSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterTaxRatesRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewTaxRatesResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewTaxRatesResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
